import { useAxios } from "utils/axiosHook";

// 月次出席レポートを取得するAPI
export const useGetMonthlyReport = () => {
  const [{ data, loading, error }, api] = useAxios<any, any, any>(
    {
      url: "report/attendances/monthly_report",
      method: "GET",
    },
    { manual: true }
  );

  const service = (params: {
    gradeId: number;
    sectionId: number;
    year: number;
    month: number;
  }) => {
    return api({
      params,
      responseType: 'blob', // Excelファイルのためblob形式で受信
    });
  };

  return { data, loading, error, service };
};
